import { CatalogConditions, OrderConditions } from "@dashboard/discounts/types";
import { getSearchFetchMoreProps } from "@dashboard/hooks/makeTopLevelSearch/utils";
import { Option } from "@saleor/macaw-ui-next";

import { useCategorieOptions } from "./options/useCategorieOptions";
import { useCollectionOptions } from "./options/useCollectionOptions";
import { useProductOptions } from "./options/useProductOptions";
import { useVariantOptions } from "./options/useVariantOptions";

export interface FetchOptions {
  fetch: (query: string) => void;
  fetchMoreProps?: ReturnType<typeof getSearchFetchMoreProps>;
  options: Option[];
}

export const useCondtionValues = (
  channel: string | null,
  conditionId: string | null,
) => {
  const productSearch = useProductOptions(channel, conditionId);
  const collectionSearch = useCollectionOptions(channel, conditionId);
  const categorySearch = useCategorieOptions(channel, conditionId);
  const variantSearch = useVariantOptions(channel, conditionId);

  const typeToFetchMap: Record<
    CatalogConditions | Extract<OrderConditions, "products" | "variants">,
    FetchOptions
  > = {
    product: productSearch,
    collection: collectionSearch,
    category: categorySearch,
    variant: variantSearch,
    // Order rules use the API field names for the same searches
    products: productSearch,
    variants: variantSearch,
  };

  const getConditionValuesFetchProps = (
    type: string,
  ): FetchOptions | undefined => {
    return typeToFetchMap[type as keyof typeof typeToFetchMap];
  };

  return {
    getConditionValuesFetchProps,
  };
};
